import { assign } from 'xstate';

import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const resetLastKnowModifications: CustomizationMachineAction = assign(() => {
  return {
    lastKnownModifications: undefined,
    lastKnownMixedDressingDetails: [],
  };
});
